<ng-container *ngIf="(tabs$ | async)?.length > 0; then tabsAvailable; else noTabsAvailable"></ng-container>

<ng-template #tabsAvailable>
   <div *samwebVar="tabs$ | async; let tabs" class="sam-full-width sam-full-height">
      <kendo-tabstrip
         fxFill
         [tabPosition]="(tabPosition$ | async)?.kendoValue"
         [keepTabContent]="true"
         [class.tab-brick-tabstrip]="'true'"
         [class.allow-tab-overflow]="allowBrickOverflow"
         (tabSelect)="tabSelected($event.index, tabs)"
      >
         <kendo-tabstrip-tab *ngFor="let tab of tabs; let i = index" [selected]="(selectedTab$ | async) === i">
            <ng-template kendoTabTitle class="k-tabstrip-items">
               <samweb-tab-brick-title
                  [tabHostBrickInstanceId]="brickInstanceId"
                  [tab]="tab"
                  [tabPosition]="(tabPosition$ | async)?.kendoValue"
               ></samweb-tab-brick-title>
            </ng-template>
            <ng-template kendoTabContent *samwebLazyLoadIf="(selectedTab$ | async) === i" class="k-tabstrip-content">
               <!-- tab content, so the hosting of the content brick itself is here -->
               <samweb-brick-container [brickInstanceId]="tab.brickInstanceId"></samweb-brick-container>
            </ng-template>
         </kendo-tabstrip-tab>
      </kendo-tabstrip>
   </div>
</ng-template>

<ng-template #noTabsAvailable>
   <div fxFill class="no-tabs sam-margin">
      <div fxFill fxLayoutAlign="center center" fxLayout="column">
         <fa-icon class="sam-margin" size="3x" [icon]="tabIcon"></fa-icon>
         <span>
            {{ 'brick.brick_definitions.tab-brick.no_tabs_added' | translate }}
         </span>
      </div>
   </div>
</ng-template>
